import React, { useState } from 'react';
import ConfigTab from './admin/ConfigTab';
import ActivitiesTab from './admin/ActivitiesTab';
import UsersTab from './admin/UsersTab';
import '../admin.css';

export default function AdminPanel({ config, updateConfig, onClose }) {
  const [activeTab, setActiveTab] = useState('config');

  return (
    <div className="admin-overlay">
      <div className="admin-panel">
        <div className="admin-panel-header">
          <h2>⚙️ Panel de Administración</h2>
          <button className="admin-close-btn" onClick={onClose}>✕</button>
        </div>

        <div className="admin-tabs">
          <button className={`admin-tab ${activeTab === 'config' ? 'active' : ''}`} onClick={() => setActiveTab('config')}>
            Configuración
          </button>
          <button className={`admin-tab ${activeTab === 'users' ? 'active' : ''}`} onClick={() => setActiveTab('users')}>
            Usuarios
          </button>
          <button className={`admin-tab ${activeTab === 'activities' ? 'active' : ''}`} onClick={() => setActiveTab('activities')}>
            Actividades
          </button>
        </div>

        <div className="admin-panel-content">
          {activeTab === 'config' && <ConfigTab config={config} updateConfig={updateConfig} />}
          {activeTab === 'users' && <UsersTab config={config} />}
          {activeTab === 'activities' && <ActivitiesTab config={config} />}
        </div>
      </div>
    </div>
  );
}
